export const baseUrl = "https://16.171.64.245/server/";
export const currentYear = "2023";
export const previousYear = "2022";
